// Mirror dari lotus-be-express/src/modules/livechat/constants/livechat.constants.ts — jaga tetap sinkron.

export const LEAD_TYPES = ["Sulit Closing", "Sedang", "Mudah Closing"];
export const GENDERS = ["Male", "Female"];

export const OCCASIONS = [
    "Ulang Tahun", "Anniversary", "Kelahiran Bayi", "Wisuda", "Grand Opening",
    "Promosi Jabatan", "Hari Valentine", "Hari Ibu/Ayah", "Natal/Tahun Baru",
    "Imlek/Lebaran", "Kejutan Romantis", "Ucapan Semangat", "Cepat Sembuh", "Ucapan Duka Cita",
];

export const REASON_GROUPS = {
    Customer: [
        "Perubahan keputusan pribadi",
        "Acara dibatalkan atau diundur",
        "Tidak ada niat awal membeli (leads dingin)",
        "Hanya mencari informasi atau perbandingan",
        "Salah memahami produk atau fitur layanan",
    ],
    Harga: [
        "Harga terlalu mahal",
        "Harga kompetitor lebih murah",
        "Tidak ada promo atau diskon menarik",
        "Anggaran tidak mencukupi",
        "Tidak sesuai dengan ekspektasi nilai/manfaat",
    ],
    Lokasi: [
        "Lokasi Customer di luar jangkauan layanan",
        "Alamat sulit dijangkau oleh kurir",
        "Area tidak tersedia di pengiriman",
        "Lokasi toko jauh dari alamat customer",
        "Zona geografis berisiko atau tidak sesuai",
    ],
    Ongkir: [
        "Ongkos kirim terlalu mahal",
        "Tidak tersedia opsi pengiriman ekonomis",
        "Biaya tambahan tidak disetujui pelanggan",
    ],
    Payment: [
        "Metode pembayaran tidak sesuai",
        "Gangguan sistem pembayaran",
        "Transaksi gagal secara teknis",
    ],
    Product: [
        "Produk habis (out of stock)",
        "Produk tidak sesuai ekspektasi (desain/warna)",
        "Kualitas produk diragukan",
        "Estimasi pengerjaan/pengiriman terlalu lama",
    ],
    Random: [
        "Alasan insidental unik",
        "Pembatalan tanpa penjelasan jelas",
    ],
    Sales: [
        "Respons sales lambat",
        "Informasi dari sales kurang jelas",
        "Terjadi miskomunikasi sales-pelanggan",
        "Sales tidak sesuai SOP",
    ],
    Tagline: [
        "Klik tagline tanpa minat beli",
        "Klik dilakukan tidak sengaja",
        "Tidak ada tindak lanjut setelah klik",
    ],
    Visit: [
        "Batal datang ke toko",
        "Jadwal kunjungan berubah",
        "Tidak ada konfirmasi dari pelanggan",
        "Pelanggan ingin beli offline",
    ],
};

export const QUICK_LABELS = [
    { label: "Komplain Keterlambatan", color: "#FA8072" }, // Salmon
    { label: "Komplain Produk Tidak Sesuai", color: "#FFC0CB" }, // Pink
    { label: "Komplain Layu/Rusak", color: "#9370DB" }, // Ungu
    { label: "Komplain Pesanan Tidak Dibuatkan", color: "#8B5E3C" }, // Coklat
    { label: "Komplain Laporan", color: "#4B0082" }, // Indigo
    { label: "Konfirmasi Pesanan", color: "#4169E1" }, // Biru
    { label: "Lain-lain", color: "#008080" }, // Teal
    { label: "Laporan", color: "#FFA500" }, // Oranye
];

export const MAIN_LABELS = ["pending", "cancel"];
export const RANDOM_LABEL = "random";
